import { render, staticRenderFns } from "./YearSelect.vue?vue&type=template&id=0f82cb0a&scoped=true&"
import script from "./YearSelect.vue?vue&type=script&lang=ts&"
export * from "./YearSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f82cb0a",
  null
  
)

export default component.exports